import React from 'react'

import styled from '@emotion/styled'

const Container = styled.div`
  display: block;
`

export default class Logo extends React.Component {
  render() {
    const color = this.props.color ? this.props.color : '#00ab84';
    return(
      <Container>
        <svg xmlns="http://www.w3.org/2000/svg" width="78.54" height="39.99" viewBox="0 0 78.54 39.99">
          <g>
            <path d="M48 26.32S48.15 40 34.78 40c-7.64 0-10.85-4.23-11.93-6.26l-.57-1.47-.28-.96h5.47l.15.54s1.06 3.25 6.75 3.47a8.35 8.35 0 008.27-5.82l.27-1.31.09-.69.14-1.5v-4.59h-4.75v-4.69h4.88V8.78h-5.59l-.21 1.19V10l-1.18 7.2h-4.76L34 4.29h14v22m15.79-1.07v4.91c-4.79-3.46-13.68-4.49-13.68-4.49h-.18V21h.18s9.17 1.65 13.57 4.16l.11.06M78.52 18a12.4 12.4 0 01-5.2 9.82A14.47 14.47 0 0165.41 30h-.34v-4.5h1.57l1.54-.25H68.39c6.18-1.43 5.91-8.21 5.89-8.21V11h4.24v7M8.68 24.71c0 .15.23.37.84.35h6.05v4.7H8.91c-4.48-.36-4.51-5.24-4.5-5.25v-.3L4.31 23v-5.86H.07v-4.5h4.24V8.92H.07v-.79L0 8.06V4.22h15.49v4.7H8.7v3.65h6.79v4.63H8.7v7.51m21.5-5.14s-1.52 9.47-11.65 10H17V25.2h.12l1.2-.06h.34c8.21-1 7.6-8.19 7.58-8.18v-6.22h4.24v6.15l-.17 2.42v.24m33-5.92l-.58 4.5-13.21-1.52.56-4.49 5.45.61 7.63.9m3-10.07l8.47 3.06.26.1L73.3 11l-8.78-3.17 1.64-4.25h.1m-39.42 3l-1.59 4-.47-.07v-.05l-.33-.09-.06-.06-8.02-2.81L18 3.26l8.84 3.18v.16m36.57-1.37l-.58 4.51L49.71 8.2l.59-4.49-.07-.06 13.18 1.58M45.9 2A2.05 2.05 0 0150 2a2.05 2.05 0 01-4.1 0m-4.37 0a2.07 2.07 0 014.13 0 2.07 2.07 0 01-4.13 0" fill={color} fillRule="evenodd" data-name="レイヤー 1"/>
          </g>
        </svg>
      </Container>
    )
  }
}
